/**
 * 智能看护设备总览 - API 接口
 */

import { get } from '@/utils/request'

const BASE = 'dmc/intellectOverview'

export function getOverviewSummary(params) {
  return get(`${BASE}/summary`, params)
}

export function getCoreStats(params) {
  return get(`${BASE}/coreStats`, params)
}

export function getDeviceAlarmBrief(params) {
  return get(`${BASE}/deviceAlarmBrief`, params)
}

export function getDailyAlarm(params) {
  return get(`${BASE}/dailyAlarm`, params)
}

export function getAlarmSourcePie(params) {
  return get(`${BASE}/alarmSourcePie`, params)
}

export function getDeviceOnlineRate(params) {
  return get(`${BASE}/deviceOnlineRate`, params)
}

export function getAlarmTrend(params) {
  return get(`${BASE}/alarmTrend`, params)
}

export function getTopAlarmElders(params) {
  return get(`${BASE}/topAlarmElders`, params)
}

export function getPendingAlarms(params) {
  return get(`${BASE}/pendingAlarms`, params)
}

export function getDeviceTypeList(params) {
  return get(`${BASE}/deviceTypeList`, params)
}

export function getMonthlyStats(params) {
  return get(`${BASE}/monthlyStats`, params)
}

export function getDailyStats(params) {
  return get(`${BASE}/dailyStats`, params)
}

export function getDailyAlarmTrend(params) {
  return get(`${BASE}/dailyAlarmTrend`, params)
}
